import React from 'react'
import { Feature as FeatureType } from './../utils/objects'
import { Icon, Typography } from 'foundations-library/components'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { processLink } from '../utils/utils'

const useStyles = makeStyles((theme) => {
    const { colors } = theme['foundations-library']

    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            borderLeft: `2px solid ${colors.primary[400]}`,
            padding: '0 4px 0 8px',
            columnGap: '4px',
            width: 'min-content',
            '& .text': {
                whiteSpace: 'nowrap'
            },
            '&:hover': {
                cursor: ({ link }: { link?: string }) => link ? 'pointer' : 'initial',
                backgroundColor: ({ link }: { link?: string }) => link ? 'rgba(0,0,0,.05)' : 'initial'
            }
        }
    }
})

/**
 *
 */
const Feature = ({ name, link, icon }: FeatureType) => {
    const classes = useStyles({ link })
    const history = useHistory()

    return (
        <div className={`${classes.root} feature`} onClick={() => link && processLink(link, history, true)}>
            <Typography variant='h6' color='neutral-900' className={'text'}>{name}</Typography>
            {icon && <Icon name={icon} size={'medium'} color='neutral-900' />}
        </div>
    )
}

export default Feature
